<template>
    <div>
        <div class="columns">
            <div class="column is-5">
                <form-group type="text"
                            label="Company Name (if any)"
                            id="company_name"
                            v-model="form.company_name"
                            :error="form.errors.get('company_name')"
                            @event="form.listen(form, $event)">
                </form-group>

                <form-group type="text"
                            label="Recipient Nick Name"
                            id="nick_name"
                            v-model="form.nick_name"
                            :error="form.errors.get('nick_name')"
                            @event="form.listen(form, $event)">
                </form-group>

                <form-group type="text"
                            label="First Name"
                            id="first_name"
                            v-model="form.first_name"
                            :error="form.errors.get('first_name')"
                            @event="form.listen(form, $event)">
                </form-group>

                <form-group type="text"
                            label="Last Name"
                            id="last_name"
                            v-model="form.last_name"
                            :error="form.errors.get('last_name')"
                            @event="form.listen(form, $event)">
                </form-group>

                <form-group type="tel"
                            label="Phone"
                            id="phone"
                            v-model="form.phone"
                            :error="form.errors.get('phone')"
                            @event="form.listen(form, $event)">
                </form-group>

                <form-group type="text"
                            label="Email"
                            id="email"
                            v-model="form.email"
                            :error="form.errors.get('email')"
                            @event="form.listen(form, $event)">
                </form-group>

            </div>
            <div class="column is-7">

                <form-group type="text"
                            label="Address Line 1"
                            id="line1"
                            v-model="form.line1"
                            :error="form.errors.get('line1')"
                            @event="form.listen(form, $event)">
                </form-group>

                <form-group type="text"
                            label="Address Line 2"
                            id="line2"
                            v-model="form.line2"
                            :error="form.errors.get('line2')"
                            @event="form.listen(form, $event)">
                </form-group>

                <form-group type="text"
                            label="Address Line 3"
                            id="line3"
                            v-model="form.line3"
                            :error="form.errors.get('line3')"
                            @event="form.listen(form, $event)">
                </form-group>

                <form-group type="text"
                            label="City"
                            id="city"
                            v-model="form.city"
                            :error="form.errors.get('city')"
                            @event="form.listen(form, $event)">
                </form-group>

                <form-group type="states"
                            label="State"
                            id="state"
                            v-model="form.state"
                            :error="form.errors.get('state')"
                            @event="form.listen(form, $event)">
                </form-group>

                <form-group type="text"
                            label="Zip"
                            id="zip"
                            v-model="form.zip"
                            :error="form.errors.get('zip')"
                            @event="form.listen(form, $event)">
                </form-group>

                <form-group type="text"
                            label="Country"
                            id="country"
                            v-model="form.country"
                            :error="form.errors.get('country')"
                            @event="form.listen(form, $event)">
                </form-group>

                <form-group type="checkbox"
                            label="Is Residential Address"
                            id="residential"
                            v-model="form.residential"
                            :error="form.errors.get('residential')"
                            @event="form.listen(form, $event)">
                </form-group>

            </div>
        </div>
        <div class="has-text-centered">
            <button type="button" class="button is-primary" @click="submit()">{{ create ? 'Create Recipient' : 'Save Changes' }}</button>
        </div>
    </div>
</template>

<script>
    import Form from "../../helpers/Form"
    import {CREATE_USER_RECIPIENT, UPDATE_USER_RECIPIENT} from "../../store/mutation-types"
    export default {
        props: {
            recipient: {
                type: [String, Object], default: () => {
                    return {
                        company_name: null,
                        nick_name: null,
                        first_name: null,
                        last_name: null,
                        phone: null,
                        email: null,
                        line1: null,
                        line2: null,
                        line3: null,
                        city: null,
                        state: null,
                        zip: null,
                        country: null,
                        timezone: null,
                        residential: null,
                    }
                }
            },
            userId: {type: [Number]},
            create: {type: [Boolean], default: false}
        },
        data() {
            return {
                form: new Form(this,
                    this.create ? Object.assign({}, this.recipient, {user_id: this.userId}) : this.recipient,
                    this.create ? CREATE_USER_RECIPIENT : UPDATE_USER_RECIPIENT)
            }
        },
        methods: {
            submit() {
                this.form.submit().then(data => {
                    this.$emit('saved', data)
                })
            }
        }
    };
</script>



// WEBPACK FOOTER //
// UserRecipientForm.vue?1653967a